import { roleSchema } from './role';
import { organizationSchema } from './organization';
import { providerSchema } from './provider';
import { siteSchema } from './site';
import { z } from 'zod';

export const userStatusEnum = ['active', 'inactive'] as const;

export const baseUserSchema = z.object({
  id: z.guid(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string().regex(/^\+1\d{10}$/),
  status: z.string(),
  cognitoID: z.string(),
  roleID: z.string().nullable(),
  organizationID: z.string().nullable(),
  providerID: z.string().nullable(),
});

export const userSchema = baseUserSchema.extend({
  providers: z.lazy(() => providerSchema.array()).nullable(),
  role: z.lazy(() => roleSchema).nullable(),
  organization: z.lazy(() => organizationSchema).nullable(),
  sites: z
    .lazy(() => siteSchema.array())
    .nullable()
    .optional(),
});

export const userSummarySchema = baseUserSchema
  .pick({
    id: true,
    firstName: true,
    lastName: true,
    email: true,
  })
  .strict();

export const createUserSchema = baseUserSchema.omit({
  id: true,
  status: true,
  cognitoID: true,
});

export const updateUserSchema = userSchema.extend({
  allowedSiteIDs: z.array(z.guid()).optional().nullable(),
});
